const BLOCKER_LABELS = {
  open_tasks: "Відкриті задачі",
  open_viewings: "Відкриті перегляди",
  open_deals: "Відкриті угоди",
  active_shares: "Активні поширення",
  financial_ties: "Фінансові зв'язки",
  unresolved_counterparty_finance: "Незавершені фінанси контрагента",
};

const RELATION_LABELS = {
  shares: "Поширення",
  grants: "Доступи",
  tasks: "Задачі",
  viewings: "Перегляди",
  presentations: "Презентації",
  deals: "Угоди",
  financial_ties: "Фінансові зв'язки",
};

export function blockerLabel(code) {
  if (!code) return "Невідома перешкода";
  return BLOCKER_LABELS[code] || `Невідомий код: ${code}`;
}

export function relationLabel(key) {
  if (!key) return "Зв'язок";
  return RELATION_LABELS[key] || key;
}

/**
 * Map C1 nested relation objects to display rows.
 * Does not invent zeros for unknown structures; skips non-objects.
 */
export function relationEntries(relations) {
  if (!relations || typeof relations !== "object") return [];
  const entries = [];
  Object.entries(relations).forEach(([key, value]) => {
    if (value == null || typeof value !== "object" || Array.isArray(value)) {
      return;
    }
    const parts = [];
    if (typeof value.count === "number") {
      parts.push(`всього ${value.count}`);
    }
    if (typeof value.active === "number") {
      parts.push(`активні ${value.active}`);
    }
    if (typeof value.expired === "number") {
      parts.push(`закінчені ${value.expired}`);
    }
    if (typeof value.open === "number") {
      parts.push(`відкриті ${value.open}`);
    }
    if (typeof value.closed === "number") {
      parts.push(`закриті ${value.closed}`);
    }
    if (typeof value.owner_plans === "number") {
      parts.push(`плани власника ${value.owner_plans}`);
    }
    if (typeof value.owner_payments === "number") {
      parts.push(`платежі власника ${value.owner_payments}`);
    }
    if (typeof value.counterparty_plans_present === "boolean") {
      parts.push(
        value.counterparty_plans_present
          ? "є плани контрагента"
          : "немає планів контрагента",
      );
    }
    if (parts.length === 0) return;
    entries.push({
      key,
      label: relationLabel(key),
      summary: parts.join(" · "),
    });
  });
  return entries;
}
